import { useParams } from 'react-router-dom';
import InstallmentsTableComponent from '../../shared/installments-table/installments-table.component';

export default function ProviderReceivableInfo() {
  const { id } = useParams();

  return <InstallmentsTableComponent providerId={id} />;
}
